<ax-domain-edit
  [form]="(form$ | async) || undefined"
  [label]="label"
  [postfix]="postfix"
  [readonly]="readonly"
  howToLink="https://aztrix.atlassian.net/servicedesk/customer/portal/8/article/3005087745"
></ax-domain-edit>
